/* Copyright (c) 2023 Xperi. All Rights Reserved. */
/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import { Log } from '../logging/Log';

export class Locale {
    private static TAG = 'Locale';

    private static languageMap: Object = {};

    static setLocale = (locale: string, msoName?: string, platform?: string) => {
        const localeArr = locale.split('_');
        const language = localeArr[0].toLowerCase();
        const region = localeArr[1].toLowerCase();
        let languageFile = {};
        let regionLanguageFile = {};
        let platformLanguageFile = {};
        let msoLanguageFile = {};

        try {
            languageFile = require(`../../assets/locales/${language}_any_any_unmanaged_smarttv.json`);
        } catch (err: any) {
            Log.i(Locale.TAG, err.message, 'Using default locale file');
            languageFile = require('../../assets/locales/en_any_any_unmanaged_smarttv.json');
        }

        try {
            regionLanguageFile = require(`../../assets/locales/${language}_${region}_any_unmanaged_smarttv.json`);
        } catch (err: any) {
            Log.e(Locale.TAG, err.message);
        }

        try {
            msoLanguageFile = require(`../../assets/locales/${language}_${region}_${msoName}_unmanaged_smarttv.json`);
        } catch (err: any) {
            Log.e(Locale.TAG, err.message);
        }

        try {
            platformLanguageFile = require(`../../assets/locales/${language}_any_any_${platform?.toLowerCase()}_unmanaged_smarttv.json`);
        } catch (err: any) {
            Log.e(Locale.TAG, err.message);
        }

        Object.assign(Locale.languageMap, languageFile);
        Object.assign(Locale.languageMap, regionLanguageFile);
        Object.assign(Locale.languageMap, msoLanguageFile);
        Object.assign(Locale.languageMap, platformLanguageFile);
    };

    static getString = (key: string): string => {
        return Locale.languageMap[key] || '';
    };
}
